import { useEffect } from 'react';

/**
 * Custom hook to update browser tab title and favicon based on store branding
 * @param {Object} store - Store object with name, tagline, logo, and settings
 * @param {string} pageSuffix - Optional suffix to add to the title (e.g., "Shop", "About")
 */
export const useStoreBranding = (store, pageSuffix = '') => {
  useEffect(() => {
    if (store) {
      // Update page title
      const tagline = store.settings?.tagline || store.tagline;
      let title = store.name || 'Store';

      if (pageSuffix) {
        title = `${pageSuffix} - ${title}`;
      } else if (tagline) {
        title = `${title} - ${tagline}`;
      }

      document.title = title;

      // Update favicon
      if (store.logo) {
        // Remove existing favicons
        const existingFavicons = document.querySelectorAll('link[rel="icon"], link[rel="shortcut icon"], link[rel="apple-touch-icon"]');
        existingFavicons.forEach(favicon => favicon.remove());

        // Create new favicon link
        const favicon = document.createElement('link');
        favicon.rel = 'icon';
        favicon.type = 'image/x-icon';
        favicon.href = store.logo;
        document.head.appendChild(favicon);

        // Also create apple-touch-icon for better mobile support
        const appleTouchIcon = document.createElement('link');
        appleTouchIcon.rel = 'apple-touch-icon';
        appleTouchIcon.href = store.logo;
        document.head.appendChild(appleTouchIcon);
      }
    }

    // Cleanup function to restore default on unmount
    return () => {
      document.title = 'Revstar';
    };
  }, [store, pageSuffix]);
};
